
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 257.95 172.91"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3c3c3b","d":"M0 0h257.95v172.91H0z"}}),_c('path',{attrs:{"fill":"#25262a","d":"M0 0h257.95v172.91H0z"}}),_c('text',{attrs:{"transform":"translate(98.13 99.91)","font-size":"7.284","fill":"#d8b358","font-family":"Raleway-Medium,Raleway","font-weight":"500","letter-spacing":".044em"}},[_c('tspan',{attrs:{"x":"2.16","y":"0","letter-spacing":".075em"}},[_v('ARCHIT')]),_c('tspan',{attrs:{"x":"31.89","y":"0","letter-spacing":".061em"}},[_v('E')]),_c('tspan',{attrs:{"x":"36.74","y":"0","letter-spacing":".075em"}},[_v('CTURE D’INTERIEUR')])]),_c('path',{attrs:{"fill":"#d8b358","d":"M89.25 59.27h2.79v54.37h-2.79z"}}),_c('text',{attrs:{"transform":"translate(98.13 89.29)","font-size":"23.001","fill":"#d8b358","font-family":"Georgia"}},[_v('L’ATELIER')]),_c('path',{attrs:{"d":"M77.42 96.15l-18 10.43-17.89-10.42V75.49L59.4 65l18 10.41zm-18-29.46l-16.28 9.45v19.33l16.35 9.42 16.34-9.5V76.15z","fill":"#d8b358"}}),_c('path',{attrs:{"d":"M44.82 77.62l14.58-8.54 14.68 8.46V94l-14.59 8.59L44.82 94zm1.58 15.77l13.08 7.48 13-7.47V78.17l-13-7.45-13 7.5z","fill":"#d8b358"}}),_c('path',{attrs:{"d":"M58.6 89.26L55 87.14v5.37l-.7.4-.83-.48v-13L59.89 76v6.75l5.31 3v6.5l-.84.47-.66-.38v-5.25c-1.49.86-3.79 2.32-3.79 2.32v5.88l-.71.43-.62-.38zm.87-1.26l3.59-2.26-3.59-2-3.59 2.07zm-4.85-3.11l4.21-2.38V81l-4.2 2.3zm0-3.21c1.45-.87 4.17-2.31 4.17-2.31v-1.53s-3.06 1.65-4.17 2.31z","fill":"#d8b358"}})])
          )
        }
      }
    